import script from "./collection-applied-filters.vue?vue&type=script&setup=true&lang=js"
export * from "./collection-applied-filters.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__